
import ReactDOM from "react-dom";
import "./index.css";
import ApolloProvider from "./ApolloProvider";

ReactDOM.render(ApolloProvider, document.getElementById("root"));
